export default __webpack_public_path__ + "255bd76acb7bcad70cee20e1a0c57b5e.png";